export default "__VITE_ASSET__22pPWMe0__"